import { DISPLAYSIZECHANGE, LOGINSTATE, LOADING, LANGUAGECODE, PAGEISLOADED, AUTHCHECKED } from "../constants/mainConst";

export const mainStore = (state = {}, action) => {
	switch (action.type) {
		case DISPLAYSIZECHANGE: {
			return {
				...state,
				DisplaySizeChange: state.DisplaySizeChange + action.payload
			};
		}

		case LOGINSTATE: {
			return {
				...state,
				loginState: action.payload
			};
		}

		case LOADING: {
			return {
				...state,
				loading: action.payload
			}
		}
		
		case LANGUAGECODE: {
			return {
				...state,
				languageCode: action.payload
			}
		}

		case PAGEISLOADED: {
			return {
				...state,
				pageIsLoaded: action.payload
			}
		}

		case AUTHCHECKED: {
			return {
				...state,
				authChecked: action.payload
			}
		}

		default: {
			return { ...state };
		}
	}
};
